module.exports = __webpack_public_path__ + "img/loading_bars.6b30e98c.svg";